import flatpickr from 'flatpickr';
import {French} from 'flatpickr/dist/l10n/fr.js';

import Swiper from 'swiper/bundle';


import profil from "../utils/profil";
import events from "./events";
import fiches from "./fiches";


const compte = {
    _modalEl: null,
    _msgEl: null,
    _waitTimer: null,
    _lastBtn: null,
    init() {
        this.initMedias();
        profil.init();
        events.init();
        fiches.initConfirm();
        this.cacheModal();
        this.initFlatpickrs();
        this.bindFormSubmitWait();
        this.initSwiper();
        this.validPostulation();
        this.loadButtons();
    },
    loadButtons() {

        if ($(".__mod_event").hasClass("_show_bl")) {
            $(".__gest_event").addClass("_middle");
        }

        $(document).on("click", "._open_notes", function () {
            $(".__notes").toggle();
            $(".__mod_event").removeClass("_show_bl").hide();
            $(".__gest_event").toggleClass("_middle");
        });

        $(document).on("click", "._open_mod", function () {
            $(".__mod_event").removeClass("_show_bl").toggle();
            $(".__notes").hide();
            $(".__gest_event").toggleClass("_middle");
        });

        $(document).on("click", "._close_mod", function () {
            $(".__mod_event").removeClass("_show_bl").hide();
            $(".__gest_event").removeClass("_middle");
        });
    },
    validPostulation() {

        $(document).on("change", 'select[name="_filter_postulations"]', function () {
            const statut = $(this).val();
            const $items = $(".__postulations > li");

            if (!statut || statut === "all") {
                $items.removeClass("_hidden");
                return;
            }

            $items.each(function () {
                const s = $(this).data("statut");
                $(this).toggleClass("_hidden", s !== statut);
            });
        });


        $(document).on("click", "._open_bl", function (e) {
            e.preventDefault();

            const id = $(this).data("id");                         // "VALID" | "REFUS"
            const $li = $(this).closest("li");                      // <li> courant
            const $card = $li.find(".__fiche_groupe").first();        // carte courante
            const $target = $card.find(`.block-hide[data-id="${id}"]`).first();

            // Fermer tout ce qui est ouvert (partout)
            $(".block-hide._open").not($target)
                .removeClass("_open")
                .stop(true, true).slideUp(150);

            // Toggle du panneau cible
            const willOpen = !$target.hasClass("_open");
            if (willOpen) {
                $target.addClass("_open").stop(true, true).slideDown(180);
            } else {
                $target.removeClass("_open").stop(true, true).slideUp(150);
            }

            // État visuel des boutons (optionnel)
            $card.find("._open_bl").removeClass("_active");
            if (willOpen) $(this).addClass("_active");

            // ---- Gestion de _inwait sur les <li> ----
            const $allLis = $li.closest(".__postulations").find("> li");
            if (willOpen) {
                // mettre tous en attente puis retirer sur l’actuel
                $allLis.addClass("_inwait");
                $li.removeClass("_inwait");
            } else {
                // plus rien d’ouvert -> retirer l’attente partout
                $allLis.removeClass("_inwait");
            }
        });

    },
    initMedias() {
        $(document).on("click", "._btn_add_media", function () {
            $("._add_media").addClass("_show");
        });
    },
    initSwiper() {

        const swiper = new Swiper(".__nav_account", {
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: {enabled: true},
            watchOverflow: true,
            grabCursor: true,
        });


        if ($(".__events").length > 0) {
            const swiper = new Swiper(".__events", {
                slidesPerView: 3,
                watchOverflow: false,
                breakpoints: {
                    0: {slidesPerView: 1},
                    640: {slidesPerView: 1.3},
                    768: {slidesPerView: 2},
                    992: {slidesPerView: 3}
                },
                navigation: {
                    nextEl: ".evt-next",
                    prevEl: ".evt-prev"
                },
            });
            setTimeout(() => swiper.update(), 500);
        }

        if ($(".__medias").length > 0) {

            const swiper_medias = new Swiper(".__medias", {
                slidesPerView: 2.5,
                spaceBetween: 40,
                watchOverflow: false,
                breakpoints: {
                    0: {
                        slidesPerView: 1.1,
                        spaceBetween: 10,
                    },
                    640: {
                        slidesPerView: 1.8,
                        spaceBetween: 20,
                    },
                    992: {
                        slidesPerView: 2.5,
                        spaceBetween: 40,
                    }
                },
                navigation: {
                    nextEl: ".evt-next",
                    prevEl: ".evt-prev"
                },
            });
            fiches.setupMediaGallery(swiper_medias);
        }
    },
    cacheModal() {
        this._modalEl = document.querySelector('.__modal_wait');
        this._msgEl = this._modalEl ? this._modalEl.querySelector('span.__msg_desc') : null;
        if (this._modalEl) this._modalEl.classList.remove('_show'); // caché par défaut
    },

    showWait(message = 'Traitement en cours, merci de patienter…') {
        if (this._msgEl) this._msgEl.textContent = message;
        if (this._modalEl) this._modalEl.classList.add('_show');
    },

    bindFormSubmitWait(root = document) {
        root.querySelectorAll('form').forEach((form) => {
            if (form._waitBound) return;
            form._waitBound = true;

            form.addEventListener('submit', (e) => {
                const btn = e.submitter;
                if (!btn || !btn.classList || !btn.classList.contains('_btn_with_wait')) return;
                const msg = btn.getAttribute('data-wait-msg') || 'Traitement en cours, merci de patienter…';
                this.showWait(msg);
            });
        });
    },
    initFlatpickrs(root = document) {

        root.querySelectorAll('.js-flatpickr').forEach(el => {
            if (el._flatpickr) return;

            const min = new Date();
            min.setDate(min.getDate() + 2);

            let disabledDates = [];

            if (el.dataset.disabledDates) {
                try {
                    disabledDates = JSON.parse(el.dataset.disabledDates);
                } catch (e) {
                    disabledDates = [];
                }
            }

            flatpickr(el, {
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'd-m-Y',
                allowInput: true,
                minDate: min,
                disable: disabledDates,
                locale: French,
            });
        });

        root.querySelectorAll('.js-flatpickr-dt').forEach(el => {
            if (el._flatpickr) return; // évite double init
            flatpickr(el, {
                enableTime: true,
                noCalendar: true,         // ⟵ pas de calendrier
                time_24hr: true,          // ⟵ format 24h
                dateFormat: 'H:i',        // ⟵ valeur envoyée: "HH:ii" (ex: 09:30)
                minuteIncrement: 5,       // pas de 5 min (change si besoin)
                allowInput: true,         // autorise la saisie clavier
                defaultDate: el.value || null,
            });
        });


    }
};

export default compte;
